import validator from "validator";

export const dateNotInFutureFieldOptions = {
  validate: {
    isValidDate: (value: string) =>
      value &&
      !validator.isDate(value, {
        format: "YYYY/MM/DD",
        strictMode: true,
      })
        ? "Please enter a valid date in the format YYYY/MM/DD."
        : undefined,
    isBeforeToday: (value: string) =>
      value && !validator.isBefore(value)
        ? "Date cannot be in the future."
        : undefined,
  },
};

export const nameInitialOptions = {
  pattern: {
    value: /^.$/,
    message: "Please enter only one letter.",
  },
};

export const numbersWithDecimals = {
  value: /^([0-9]*[1-9][0-9]*(\.[0-9]+)?|[0]*\.[0-9]*[1-9][0-9]*)$/,
  message: "Please only enter numbers.",
};

export const healthcardNumberFieldOptions = {
  pattern: {
    value: /^[0-9-]*$/,
    message: "Please enter only numbers and dashes.",
  },
  validate: {
    digitCount: (value: string) =>
      value && !(value.replace(/\D/g, "").length === 10)
        ? "Please enter 10 digits (dashes optional)"
        : undefined,
  },
};

export const healthcardVersionCodeFieldOptions = {
  pattern: {
    value: /^[a-zA-Z]{1,2}$/i,
    message: "Please enter up to 2 alphabetic characters.",
  },
};

export const phoneNumberFieldOptions = {
  pattern: {
    value: /^[0-9-]*$/,
    message: "Please enter only numbers and dashes.",
  },
  validate: {
    digitCount: (value: string) =>
      value && !(value.replace(/\D/g, "").length === 10)
        ? "Please enter 10 digits (no country code, dashes optional)"
        : undefined,
  },
};

export const phoneExtensionFieldOptions = {
  pattern: {
    value: /^[0-9]*$/,
    message: "Please enter only numbers.",
  },
  validate: {
    digitCount: (value: string) =>
      value && value.replace(/\D/g, "").length > 6
        ? "Please enter a maximum of 6 digits."
        : undefined,
  },
};

export const postalCodeFieldOptions = {
  pattern: {
    value:
      /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    message: "Please enter in correct format",
  },
};

export const nonSpecialCharacterOptions = {
  pattern: {
    value: /^[^%<=>[\]^|]*$/,
    message: "Symbols not allowed: %, <, =, >, [, ], ^, |",
  },
};

export const shortProvinceOptions = {
  pattern: {
    value: /^(AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YT)$/,
    message: "Please enter a two letter province code like 'ON'",
  },
};

export const adpAuthRegNoOptions = {
  pattern: {
    value: /^[A-Za-z0-9]{10}(-[A-Za-z0-9]{1,2})?$/,
    message: "Must be formatted xxxxxxxxxx-xx or xxxxxxxxxx-x or xxxxxxxxxx",
  },
};
